import { approveProjectDialogViewTexts } from './approve-project';
import { createDialogCommonViewTexts } from './create-dialog-common';
import { createNewCompanyDialogViewTexts } from './create-new-company';
import { createNewKoumutenDialogViewTexts } from './create-new-koumuten';
import { createNewModelDialogViewTexts } from './create-new-model';
import { createNewProjectDialogViewTexts } from './create-new-project';
import { createNewUserDialogViewTexts } from './create-new-user';
import { deleteCompanyDialogViewTexts } from './delete-company';
import { deleteDialogCommonViewTexts } from './delete-dialog-common';
import { deleteKoumutenDialogViewTexts } from './delete-koumuten';
import { deleteModelDialogViewTexts } from './delete-model';
import { deleteModelImageDialogViewTexts } from './delete-model-image';
import { deleteProjectDialogViewTexts } from './delete-project';
import { deleteProjectImageDialogViewTexts } from './delete-project-image';
import { deleteUserDialogViewTexts } from './delete-user';
import { editCompanyDialogViewTexts } from './edit-company';
import { editKoumutenDialogViewTexts } from './edit-koumuten';
import { editModelDialogViewTexts } from './edit-model';
import { editProjectDialogViewTexts } from './edit-project';
import { editUserDialogViewTexts } from './edit-user';
import { logoutDialogViewTexts } from './logout';
import { projectImageSettingsDialogViewTexts } from './project-image-settings-dialog';
import { unapproveProjectDialogViewTexts } from './unapprove-project';

export const dialogViewTexts = {
  deleteDialogTemplate: deleteDialogCommonViewTexts,
  createDialogTemplate: createDialogCommonViewTexts,
  logout: logoutDialogViewTexts,
  approveProject: approveProjectDialogViewTexts,
  unapproveProject: unapproveProjectDialogViewTexts,
  projectImageSettings: projectImageSettingsDialogViewTexts,

  createNewKoumuten: createNewKoumutenDialogViewTexts,
  createNewCompany: createNewCompanyDialogViewTexts,
  createNewModel: createNewModelDialogViewTexts,
  createNewProject: createNewProjectDialogViewTexts,
  createNewUser: createNewUserDialogViewTexts,

  deleteKoumuten: deleteKoumutenDialogViewTexts,
  deleteCompany: deleteCompanyDialogViewTexts,
  deleteModel: deleteModelDialogViewTexts,
  deleteModelImage: deleteModelImageDialogViewTexts,
  deleteProject: deleteProjectDialogViewTexts,
  deleteProjectImage: deleteProjectImageDialogViewTexts,
  deleteUser: deleteUserDialogViewTexts,

  editKoumuten: editKoumutenDialogViewTexts,
  editCompany: editCompanyDialogViewTexts,
  editModel: editModelDialogViewTexts,
  editProject: editProjectDialogViewTexts,
  editUser: editUserDialogViewTexts
} as const;
